import React from 'react';
import { hydrate } from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import Root from '../app/Root';
hydrate(React.createElement(BrowserRouter, null,
    React.createElement(Root, null)), document.getElementById('root'));
const anyModule = module;
if (anyModule.hot) {
    anyModule.hot.accept();
}
